module.exports = __webpack_public_path__ + "img/emoji-loveeyes-240x240.f4934cbb.png";